import { ChevronRight } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import { LocalizedLink } from '@/components/LocalizedLink'

interface BreadcrumbItem {
  label: string
  to?: string
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[]
  className?: string
}

export function Breadcrumbs({ items, className }: BreadcrumbsProps) {
  const { t } = useTranslation()

  return (
    <nav
      aria-label={t('aria.breadcrumbs', 'Breadcrumb')}
      className={cn(
        'py-4 text-sm bg-ink-deep/95 backdrop-blur-md border-b border-white/10',
        className
      )}
    >
      <ol className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 flex flex-wrap items-center gap-1">
        {items.map((item, index) => {
          const isLast = index === items.length - 1
          return (
            <li key={index} className="flex items-center">
              {index > 0 && (
                <ChevronRight
                  className="mx-1 h-4 w-4 text-white/40"
                  aria-hidden="true"
                />
              )}
              {isLast || !item.to ? (
                <span
                  className="text-white/70"
                  aria-current={isLast ? 'page' : undefined}
                >
                  {item.label}
                </span>
              ) : (
                <LocalizedLink
                  to={item.to}
                  className="text-white/80 hover:text-primary transition-colors"
                >
                  {item.label}
                </LocalizedLink>
              )}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}
